import { render, staticRenderFns } from "./VistatNuxtLoader.vue?vue&type=template&id=4d926cdb&scoped=true&"
import script from "./VistatNuxtLoader.vue?vue&type=script&lang=js&"
export * from "./VistatNuxtLoader.vue?vue&type=script&lang=js&"
import style0 from "./VistatNuxtLoader.vue?vue&type=style&index=0&id=4d926cdb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d926cdb",
  null
  
)

export default component.exports